const IMAX3D = {
  rowA: {
    s1: { isSeatBooked: "Booked" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "Booked" },
    s6: { isSeatBooked: "Booked" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "Booked" },
    s11: { isSeatBooked: "Booked" },
    s12: { isSeatBooked: "Booked" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "Booked" },
    s15: { isSeatBooked: "Booked" },
    s16: { isSeatBooked: "Booked" },
    s17: { isSeatBooked: "Booked" },
    s18: { isSeatBooked: "Booked" },
    s19: { isSeatBooked: "Booked" },
    s20: { isSeatBooked: "Booked" },
  },
  rowB: {
    s1: { isSeatBooked: "Booked" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "Booked" },
    s6: { isSeatBooked: "Booked" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "Booked" },
    s11: { isSeatBooked: "Booked" },
    s12: { isSeatBooked: "Booked" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "Booked" },
    s15: { isSeatBooked: "Booked" },
    s16: { isSeatBooked: "Booked" },
    s17: { isSeatBooked: "Booked" },
  },
  rowC: {
    s1: { isSeatBooked: "Booked" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "Booked" },
    s6: { isSeatBooked: "Booked" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "Booked" },
    s11: { isSeatBooked: "Booked" },
    s12: { isSeatBooked: "Booked" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "Booked" },
    s15: { isSeatBooked: "Booked" },
    s16: { isSeatBooked: "Booked" },
    s17: { isSeatBooked: "Booked" },
  },
  // Continue for rows 4 through 15
  rowD: {
    s1: { isSeatBooked: "Booked" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "Booked" },
    s6: { isSeatBooked: "Booked" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "Booked" },
    s11: { isSeatBooked: "Booked" },
    s12: { isSeatBooked: "Booked" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "Booked" },
    s15: { isSeatBooked: "Booked" },
    s16: { isSeatBooked: "Booked" },
    s17: { isSeatBooked: "Booked" },
    s18: { isSeatBooked: "Booked" },
    s19: { isSeatBooked: "Booked" },
    s20: { isSeatBooked: "Booked" },
    s21: { isSeatBooked: "Booked" },
    s22: { isSeatBooked: "Booked" },
    s23: { isSeatBooked: "Booked" },
    s24: { isSeatBooked: "Booked" },
    s25: { isSeatBooked: "Booked" },
  },
  rowE: {
    s1: { isSeatBooked: "Booked" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "N/A" },
    s10: { isSeatBooked: "N/A" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "N/A" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "N/A" },
    s17: { isSeatBooked: "N/A" },
    s18: { isSeatBooked: "N/A" },
    s19: { isSeatBooked: "N/A" },
    s20: { isSeatBooked: "N/A" },
    s21: { isSeatBooked: "N/A" },
    s22: { isSeatBooked: "N/A" },
    s23: { isSeatBooked: "N/A" },
    s24: { isSeatBooked: "N/A" },
    s25: { isSeatBooked: "N/A" },
  },
  rowF: {
    s1: { isSeatBooked: "N/A" },
    s2: { isSeatBooked: "N/A" },
    s3: { isSeatBooked: "N/A" },
    s4: { isSeatBooked: "N/A" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "N/A" },
    s8: { isSeatBooked: "N/A" },
    s9: { isSeatBooked: "N/A" },
    s10: { isSeatBooked: "Booked" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "N/A" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "N/A" },
    s17: { isSeatBooked: "N/A" },
    s18: { isSeatBooked: "N/A" },
    s19: { isSeatBooked: "N/A" },
    s20: { isSeatBooked: "N/A" },
    s21: { isSeatBooked: "N/A" },
    s22: { isSeatBooked: "N/A" },
    s23: { isSeatBooked: "N/A" },
    s24: { isSeatBooked: "N/A" },
    s25: { isSeatBooked: "N/A" },
  },
  rowG: {
    s1: { isSeatBooked: "Booked" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "N/A" },
    s4: { isSeatBooked: "N/A" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "N/A" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "N/A" },
    s10: { isSeatBooked: "N/A" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "N/A" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "N/A" },
    s17: { isSeatBooked: "N/A" },
    s18: { isSeatBooked: "Booked" },
    s19: { isSeatBooked: "Booked" },
    s20: { isSeatBooked: "Booked" },
    s21: { isSeatBooked: "Booked" },
    s22: { isSeatBooked: "Booked" },
    s23: { isSeatBooked: "N/A" },
    s24: { isSeatBooked: "Booked" },
    s25: { isSeatBooked: "Booked" },
  },
  rowH: {
    s1: { isSeatBooked: "Booked" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "N/A" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "N/A" },
    s17: { isSeatBooked: "N/A" },
    s18: { isSeatBooked: "N/A" },
    s19: { isSeatBooked: "N/A" },
    s20: { isSeatBooked: "N/A" },
  },
  rowI: {
    s1: { isSeatBooked: "N/A" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "N/A" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "N/A" },
    s17: { isSeatBooked: "N/A" },
    s18: { isSeatBooked: "N/A" },
    s19: { isSeatBooked: "N/A" },
    s20: { isSeatBooked: "N/A" },
  },
  rowJ: {
    s1: { isSeatBooked: "N/A" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "N/A" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "N/A" },
    s17: { isSeatBooked: "N/A" },
    s18: { isSeatBooked: "N/A" },
    s19: { isSeatBooked: "N/A" },
    s20: { isSeatBooked: "N/A" },
  },
  rowK: {
    s1: { isSeatBooked: "N/A" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "N/A" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "N/A" },
    s17: { isSeatBooked: "N/A" },
    s18: { isSeatBooked: "N/A" },
    s19: { isSeatBooked: "N/A" },
    s20: { isSeatBooked: "N/A" },
  },
  rowL: {
    s1: { isSeatBooked: "N/A" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "N/A" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "N/A" },
    s17: { isSeatBooked: "N/A" },
    s18: { isSeatBooked: "N/A" },
    s19: { isSeatBooked: "N/A" },
    s20: { isSeatBooked: "N/A" },
  },
  rowM: {
    s1: { isSeatBooked: "N/A" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "N/A" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "Booked" },
    s17: { isSeatBooked: "Booked" },
    s18: { isSeatBooked: "N/A" },
    s19: { isSeatBooked: "Booked" },
    s20: { isSeatBooked: "N/A" },
  },
  rowN: {
    s1: { isSeatBooked: "N/A" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "N/A" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "N/A" },
    s17: { isSeatBooked: "N/A" },
    s18: { isSeatBooked: "N/A" },
    s19: { isSeatBooked: "N/A" },
    s20: { isSeatBooked: "N/A" },
  },
  rowO: {
    s1: { isSeatBooked: "N/A" },
    s2: { isSeatBooked: "Booked" },
    s3: { isSeatBooked: "Booked" },
    s4: { isSeatBooked: "Booked" },
    s5: { isSeatBooked: "N/A" },
    s6: { isSeatBooked: "N/A" },
    s7: { isSeatBooked: "Booked" },
    s8: { isSeatBooked: "Booked" },
    s9: { isSeatBooked: "Booked" },
    s10: { isSeatBooked: "N/A" },
    s11: { isSeatBooked: "N/A" },
    s12: { isSeatBooked: "N/A" },
    s13: { isSeatBooked: "Booked" },
    s14: { isSeatBooked: "N/A" },
    s15: { isSeatBooked: "N/A" },
    s16: { isSeatBooked: "N/A" },
    s17: { isSeatBooked: "N/A" },
    s18: { isSeatBooked: "N/A" },
    s19: { isSeatBooked: "N/A" },
    s20: { isSeatBooked: "N/A" },
  },
};

export default IMAX3D;
